import { css } from 'lit';

export const style = css`
  .light-sub-heading {
    font-weight: 400;
  }
`;
